import { FormEvent, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export function LoginPage() {
  const { user, loading, login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (!loading && user) return <Navigate to="/" replace />;

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(username, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-shell">
      <form className="auth-card surface" onSubmit={onSubmit}>
        <div className="auth-brand">
          <img className="brand-mark lg" src="/brex-logo.png" alt="Brex" />
          <div>
            <p className="brand">Brex Desktop</p>
            <h1>Sign in</h1>
          </div>
        </div>
        <p className="muted">Use the account provided by your administrator.</p>
        {error && <div className="banner error">{error}</div>}
        <label>
          Username
          <input
            autoComplete="username"
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            disabled={busy}
          />
        </label>
        <label>
          Password
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={busy}
          />
        </label>
        <button type="submit" disabled={busy || !username || !password}>
          {busy ? "Signing in…" : "Continue"}
        </button>
      </form>
    </div>
  );
}
